export const createShadows = () => {
  const shadows = Array(25).fill('0px 0 24px rgba(0, 0, 0, 0.06)');
  shadows[0] = 'none';
  return shadows;
};
